export const EMPLOYMENT_TYPE = {
    SALARIED: 'salaried',
    FREELANCE: 'freelance',
};

export const emptyCompanyForm = {
    name: '',
    employeeSize: '',
    email: '',
    website: '',
    industry: '',
    location: '',
    description: '',
    profileImageUrl: '',
};

export const emptyEmployeeForm = {
    name: '',
    wallet: '',
    email: '',
    jobTitle: '',
    department: '',
    phone: '',
    bio: '',
    hourlyRate: '',
    monthlySalary: '',
    employmentType: EMPLOYMENT_TYPE.FREELANCE,
    profileImageUrl: '',
};

export const emptyEditEmployeeForm = {
    name: '',
    email: '',
    jobTitle: '',
    department: '',
    phone: '',
    bio: '',
    hourlyRate: '',
    monthlySalary: '',
    employmentType: EMPLOYMENT_TYPE.FREELANCE,
    status: 'active',
    profileImageUrl: '',
};

export const emptyEmployeeSelfForm = {
    name: '',
    email: '',
    jobTitle: '',
    department: '',
    phone: '',
    bio: '',
    profileImageUrl: '',
};

export function companyToForm(company) {
    if (!company) return { ...emptyCompanyForm };
    return {
        name: company.name || '',
        employeeSize: company.employeeSize || '',
        email: company.email || '',
        website: company.website || '',
        industry: company.industry || '',
        location: company.location || '',
        description: company.description || '',
        profileImageUrl: company.profileImageUrl || '',
    };
}

export function employeeToEditForm(employee) {
    if (!employee) return { ...emptyEditEmployeeForm };
    return {
        name: employee.name || '',
        email: employee.email || '',
        jobTitle: employee.jobTitle || '',
        department: employee.department || '',
        phone: employee.phone || '',
        bio: employee.bio || '',
        hourlyRate: employee.hourlyRate ?? '',
        monthlySalary: employee.monthlySalary ?? '',
        employmentType:
            String(employee.employmentType || EMPLOYMENT_TYPE.FREELANCE).toLowerCase() ===
            EMPLOYMENT_TYPE.SALARIED
                ? EMPLOYMENT_TYPE.SALARIED
                : EMPLOYMENT_TYPE.FREELANCE,
        status: String(employee.status || 'active').toLowerCase(),
        profileImageUrl: employee.profileImageUrl || '',
    };
}

export function employeeToSelfForm(employee) {
    if (!employee) return { ...emptyEmployeeSelfForm };
    return {
        name: employee.name || '',
        email: employee.email || '',
        jobTitle: employee.jobTitle || '',
        department: employee.department || '',
        phone: employee.phone || '',
        bio: employee.bio || '',
        profileImageUrl: employee.profileImageUrl || '',
    };
}

export function buildCompanyPayload(form) {
    return {
        name: form.name.trim(),
        employeeSize: form.employeeSize.trim() || null,
        email: form.email.trim() || null,
        website: form.website.trim() || null,
        industry: form.industry.trim() || null,
        location: form.location.trim() || null,
        description: form.description.trim() || null,
        profileImageUrl: form.profileImageUrl.trim() || null,
    };
}

export function buildEmployeePayload(form, { includeWallet = false } = {}) {
    const payload = {
        name: form.name.trim(),
        email: form.email.trim() || null,
        jobTitle: form.jobTitle.trim() || null,
        department: form.department.trim() || null,
        phone: form.phone.trim() || null,
        bio: form.bio.trim() || null,
        hourlyRate: form.hourlyRate || null,
        monthlySalary: form.monthlySalary || null,
        employmentType:
            form.employmentType === EMPLOYMENT_TYPE.SALARIED
                ? EMPLOYMENT_TYPE.SALARIED
                : EMPLOYMENT_TYPE.FREELANCE,
        profileImageUrl: form.profileImageUrl.trim() || null,
    };
    if (includeWallet) {
        payload.wallet = form.wallet.trim();
    }
    return payload;
}

/** Returns an error message when salaried salary is missing or zero; otherwise null. */
export function validateSalariedMonthlySalary(formOrPayload) {
    const employmentType = String(
        formOrPayload?.employmentType || '',
    ).toLowerCase();
    if (employmentType !== EMPLOYMENT_TYPE.SALARIED) {
        return null;
    }
    const raw = formOrPayload?.monthlySalary;
    if (raw === null || raw === undefined || String(raw).trim() === '') {
        return 'Monthly salary is required for salaried employees.';
    }
    const amount = Number(raw);
    if (!Number.isFinite(amount) || amount <= 0) {
        return 'Monthly salary must be greater than zero for salaried employees.';
    }
    return null;
}

export function buildEmployeeSelfPayload(form) {
    return {
        name: form.name.trim(),
        email: form.email.trim() || null,
        jobTitle: form.jobTitle.trim() || null,
        department: form.department.trim() || null,
        phone: form.phone.trim() || null,
        bio: form.bio.trim() || null,
        profileImageUrl: form.profileImageUrl.trim() || null,
        profileCompleted: true,
    };
}
